import { render, staticRenderFns } from "./StallConfig.vue?vue&type=template&id=1d3d26b3&scoped=true&"
import script from "./StallConfig.vue?vue&type=script&lang=js&"
export * from "./StallConfig.vue?vue&type=script&lang=js&"
import style0 from "./StallConfig.vue?vue&type=style&index=0&id=1d3d26b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3d26b3",
  null
  
)

export default component.exports